// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-800bb2ae] .red_role{border-left:5px solid #d9808c}", ""]);
// Exports
module.exports = exports;
